import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import NavBar from './navigation/NavBar';
import MainRouts from './router/MainRouts';
import Vectors from './static/vectors';
import { hideInfo } from '../actions';
import NotificationsService, { notifIsInitializedStorageKey } from '../services/NotificationsService';
import { getUserConversationById } from '../actions/conversations';

class AppComponent extends Component {
  static propTypes = {
    error: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    asideMenuIsOpen: PropTypes.bool.isRequired,
    hideInfo: PropTypes.func.isRequired,
    getUserConversationById: PropTypes.func.isRequired
  };

  componentDidMount () {
    window.onbeforeunload = function () {
      window.localStorage.removeItem(notifIsInitializedStorageKey);
      return null;
    };
    NotificationsService.setCallbackOnNotification(this.props.getUserConversationById);
  }

  render () {
    const { info, error, hideInfo, asideMenuIsOpen, history } = this.props;
    const Warning = () =>
      error.length ? (
        <div className='alert alert-danger' role='alert'>
          {error}
          <button
            type='button'
            className='close'
            aria-label='Close'
            onClick={hideInfo}
          >&times;</button>
        </div>) : null;

    const Info = () =>
      info.length ? (
        <div className='alert alert-success' role='alert'>
          {info}
          <button
            type='button'
            className='close'
            aria-label='Close'
            onClick={hideInfo}
          >&times;</button>
        </div>) : null;

    return (
      <div id='wrapper'>
        <NavBar history={history} />
        <div className={`container-fluid ${asideMenuIsOpen ? 'disabled' : ''}`}>
          <Warning />
          <Info />
          <MainRouts />
        </div>
        <Vectors />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.error,
    info: state.info,
    asideMenuIsOpen: state.asideMenuIsOpen
  };
};

const mapDispatchToProps = { hideInfo, getUserConversationById };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppComponent));



// WEBPACK FOOTER //
// ./src/components/AppComponent.js